module.exports = __webpack_public_path__ + "img/letterheader.901b712f.png";